import React, { useState } from 'react';
import styles from './SuccessModal.module.css';
import { Close } from '@mui/icons-material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const TeamDeleteModal = ({ isOpen, onClose, onConfirm, loading, userName }) => {
  const [confirmationText, setConfirmationText] = useState('');

  const handleConfirm = () => {
    if (confirmationText === 'delete') {
      onConfirm();
      setConfirmationText('');
    } else {
      toast.error('Please type "delete" to confirm.');
    }
  };

  const handleClose = () => {
    setConfirmationText('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={handleClose}>
      <div className={styles.modalContent} onClick={e => e.stopPropagation()} style={{ maxWidth: 420 }}>
        <div className={styles.modalHeader}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <WarningAmberRoundedIcon style={{ color: '#f44336', fontSize: 32 }} />
            <h2 style={{ margin: 0, fontWeight: 700, fontSize: 20 }}>Confirm User Deletion</h2>
          </div>
          <button className={styles.closeButton} onClick={handleClose}>
            <Close fontSize="small" />
          </button>
        </div>
        <div style={{ padding: '24px', textAlign: 'center' }}>
          <p style={{ color: '#333', fontSize: 16, marginBottom: 18 }}>
            {userName ? (
              <>You are about to permanently delete <b>{userName}</b> and all related information. This action cannot be undone.<br /><br /></>
            ) : null}
            Please type <b style={{ color: '#f44336' }}>delete</b> to confirm.
          </p>
          <input
            type="text"
            autoFocus
            value={confirmationText}
            onChange={e => setConfirmationText(e.target.value)}
            disabled={loading}
            placeholder="Type 'delete' to confirm"
            style={{
              width: '100%',
              padding: '12px',
              border: '1.5px solid #bdbdbd',
              borderRadius: 6,
              fontSize: 16,
              textAlign: 'center',
              marginBottom: 18,
              outline: 'none',
              boxSizing: 'border-box',
            }}
            onFocus={e => (e.target.style.borderColor = '#f44336')}
            onBlur={e => (e.target.style.borderColor = '#bdbdbd')}
          />
          <div style={{ display: 'flex', justifyContent: 'center', gap: 12 }}>
            <button
              type="button"
              className={styles.closeSuccessButton}
              style={{ background: '#e5e7eb', color: '#374151' }}
              onClick={handleClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              className={styles.closeSuccessButton}
              style={{ background: confirmationText === 'delete' && !loading ? '#ef4444' : '#fca5a5', color: '#fff', fontWeight: 700 }}
              onClick={handleConfirm}
              disabled={confirmationText !== 'delete' || loading}
            >
              {loading ? 'Deleting...' : 'Delete'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamDeleteModal; 